import { ForjaError } from '@mxa-argos/modules/forja/lib/forja-error';
import { AdbDaemonWebUsbDeviceManager } from '@yume-chan/adb-daemon-webusb';

export function isWebUSBSupported(): boolean {
  return AdbDaemonWebUsbDeviceManager.BROWSER !== undefined;
}

export function findWebUSBManager(): AdbDaemonWebUsbDeviceManager {
  const manager = AdbDaemonWebUsbDeviceManager.BROWSER;

  if (!manager) {
    throw new ForjaError('WEBUSB_UNSUPPORTED');
  }

  return manager;
}
